var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value)+" "+_vm._s(_vm.suffix))]):_c('span',{staticClass:"mediumTwo--text"},[_vm._v("—")])])}
var staticRenderFns = []

export { render, staticRenderFns }